import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import StatusBadge from "@/components/shared/badges/Badge";
import { useTranslation } from "react-i18next";

export default function BulkActionsBar({
  candidatesType,
  selectedRows,
  setSelectedRows,
  actions,
}) {
  const { t } = useTranslation();

  if (selectedRows?.length === 0) return null;

  const hideScrollbar =
    "[scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden";

  return (
    <div
      className={`absolute bottom-12 left-1/2 z-40 flex max-w-[min(100vw-2rem,56rem)] -translate-x-1/2 flex-nowrap items-center gap-2 overflow-x-auto rounded-full border bg-white px-6 py-3 shadow-md ${hideScrollbar}`}
    >
      <span className="flex shrink-0 items-center gap-2 text-sm">
        <StatusBadge status="primary" text={selectedRows?.length} />
        {t("candidatesPage.bulk.selectedQualifier")}
      </span>

      {actions?.map((action, i) => {
        const key = action.key ?? i;
        if (typeof action.render === "function") {
          return (
            <span key={key} className="inline-flex shrink-0 items-center">
              {action.render({ selectedRows, setSelectedRows })}
            </span>
          );
        }
        return (
          <Button
            key={key}
            variant="outline"
            disabled={action.disabled}
            className={`shrink-0 normal-case ${
              candidatesType !== "talent-pool"
                ? `border-none text-sm text-secondary rounded-full`
                : `border-destructive border-1 hover:text-destructive text-sm font-medium text-destructive bg-white rounded-full`
            }`}
            size="sm"
            onClick={() => action.onClick?.(selectedRows)}
          >
            {action.label}
          </Button>
        );
      })}

      <button
        type="button"
        aria-label={t("candidatesPage.bulk.clearSelectionAria")}
        className="ms-auto inline-flex shrink-0 cursor-pointer text-secondary hover:text-foreground"
        onClick={() => setSelectedRows([])}
      >
        <X className="size-4" aria-hidden />
      </button>
    </div>
  );
}
